import { ApolloError, gql, useMutation } from '@apollo/client';
import { JobFamilyGroupModel, JobFamilyGroupCreateModelInput } from '@utmost.co/enterprise-models';
import { deleteQueryFromCache } from 'src/utils/gql/apollo/ApolloClient';

export const CREATE_JOB_FAMILY_GROUP = gql`
  mutation CreateJobFamilyGroup($jobFamilyGroup: JobFamilyGroupCreateModelInput!) {
    jobFamilyGroup: createJobFamilyGroup(mutation: $jobFamilyGroup) {
      name
      referenceId
    }
  }
`;

type Data = { createJobFamilyGroup: JobFamilyGroupModel };

type Variables = { jobFamilyGroup: JobFamilyGroupCreateModelInput };

export const useCreateJobFamilyGroup = (onCompleted: () => void, onError: (error: ApolloError) => void) => {
  const [query, { data, loading }] = useMutation<Data, Variables>(CREATE_JOB_FAMILY_GROUP, {
    onCompleted,
    onError
  });

  const create = (variables: Variables) => {
    if (loading) {
      return;
    }

    query({ variables });
    deleteQueryFromCache('jobFamilyGroups');
  };

  return { create, data, loading };
};
